import * as React from "react"

const Subheading = ({title}) => (
  <div className="flex justify-center mb-12">
    <span className="text-skin-indigo font-bold text-2xl">{title}</span>
  </div>
)

export default Subheading
